import { render, staticRenderFns } from "./GeneralLoading.vue?vue&type=template&id=305c4c01"
import script from "./GeneralLoading.vue?vue&type=script&lang=js"
export * from "./GeneralLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports